import React from 'react';
import { useAdminAllSubscriptions, useAdminCancelSubscription } from '../../../hooks/useSubscription';
import styles from './AdminTable.module.css';
import { Loader2, XCircle } from 'lucide-react';

const SubscriptionAdmin = () => {
  const { subscriptions, isLoading, error, refetch } = useAdminAllSubscriptions();
  const cancelMutation = useAdminCancelSubscription();

  const handleCancel = (subscriptionId) => {
    if (window.confirm('Are you sure you want to cancel this subscription?')) {
      cancelMutation.mutate(subscriptionId);
    }
  };

  if (isLoading) {
    return <div className={styles.loading}><Loader2 size={32} className={styles.spinner} /> Loading subscriptions...</div>;
  }
  if (error) {
    return <div className={styles.error}>Failed to load subscriptions.</div>;
  }

  return (
    <div className={styles.adminTableContainer}>
      <h2>All Subscriptions</h2>
      <table className={styles.adminTable}>
        <thead>
          <tr>
            <th>User Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Role</th>
            <th>Plan</th>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {subscriptions.length === 0 ? (
            <tr><td colSpan="9">No subscriptions found.</td></tr>
          ) : (
            subscriptions.map((sub) => (
              <tr key={sub.id}>
                <td>{sub.user_name}</td>
                <td>{sub.user_email}</td>
                <td>{sub.user_phone}</td>
                <td>{sub.user_role}</td>
                <td>{sub.plan_name}</td>
                <td>{sub.status}</td>
                <td>{new Date(sub.start_date).toLocaleDateString()}</td>
                <td>{new Date(sub.end_date).toLocaleDateString()}</td>
                <td>
                  {sub.status === 'active' ? (
                    <button
                      className={styles.cancelBtn}
                      onClick={() => handleCancel(sub.id)}
                      disabled={cancelMutation.isLoading}
                    >
                      {cancelMutation.isLoading ? <Loader2 size={16} className={styles.spinner} /> : <XCircle size={16} />} Cancel
                    </button>
                  ) : (
                    <span className={styles.inactive}>N/A</span>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default SubscriptionAdmin;